module.exports = __webpack_public_path__ + "static/224-dcc393b01e747e5acb062915ee5eff6b.png";